module.exports = __webpack_public_path__ + "img/consultoria_3-4.f9d60465.webp";